// Dashboard.jsx
import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Box,
  Button,
  Modal,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { collection, getDocs, doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

  import { toast } from "react-toastify";
  import { doSignOut } from "./auth.js";
  import { useAuth } from "./authContext";
  import firebase from "firebase/compat/app";
  import { firebaseConfig } from './firebase'
  import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
  import AddIcon from '@mui/icons-material/Add';
  import CreditScoreIcon from '@mui/icons-material/CreditScore';
  import BusinessIcon from '@mui/icons-material/Business';
  import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
  import GavelIcon from '@mui/icons-material/Gavel';
  import NoteAddIcon from '@mui/icons-material/NoteAdd';
  import CottageIcon from '@mui/icons-material/Cottage';
  import PaidIcon from '@mui/icons-material/Paid';
  import ListingItem from "../components/ListingItem.jsx";
  import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
  import NewPatientModal from './NewPatientModal.jsx.jsx'
  import LockIcon from '@mui/icons-material/Lock';
  import SpeedIcon from '@mui/icons-material/Speed';
  import SupportIcon from '@mui/icons-material/Support';
  import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
  import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
  import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
  import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
  import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
  import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
  import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
  import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
  import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
  import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
  import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
  import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
  import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
  import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
  import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
  import HouseIcon from '@mui/icons-material/House';
  import GppGoodIcon from '@mui/icons-material/GppGood';
  import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
  import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
  import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
  import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
  import LocationOnIcon from '@mui/icons-material/LocationOn';
  import PieChartIcon from '@mui/icons-material/PieChart';
  import SearchIcon from '@mui/icons-material/Search';
  import CalculateIcon from '@mui/icons-material/Calculate';
  import AddHomeIcon from '@mui/icons-material/AddHome';
  import SchoolIcon from '@mui/icons-material/School';
  import GroupIcon from '@mui/icons-material/Group';
  import PeopleIcon from '@mui/icons-material/People';
  import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
  import axios from 'axios';
  import VisibilityIcon from '@mui/icons-material/Visibility';
  import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
  import Contact from "../components/Contact.jsx";
  import {
    FaBath,
    FaBed,
    FaChair,
    FaMapMarkerAlt,
    FaParking,
    FaShare,
  } from "react-icons/fa";
  import Dmedashboard from "./dmedashboard.jsx";
  
  import { getAuth } from "firebase/auth";
  import StateModal from "./StateModal.jsx";
  import { Chip } from "@mui/material";
  import TenantModal from "./TenantModal.jsx";
  import UpsellModal from "./UpsellModal.jsx";
  import ProfileComponent from "./ProfileComponent.jsx";
const Dashboard = () => {
  // State for Firestore data
  const [users, setUsers] = useState([]);
  const [stats, setStats] = useState({ totalTraffic: 0, activeUsers: 0 });
  const [selectedUser, setSelectedUser] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  // State for push notifications tool (unchanged)
  const [pushToken, setPushToken] = useState('');
  const [notificationTitle, setNotificationTitle] = useState('');
  const [notificationBody, setNotificationBody] = useState('');
  const [notificationStatus, setNotificationStatus] = useState('');
  const { currentUser } = useAuth()
  const [user, setUser] = useState(null);

  


  useEffect(() => {
    setTimeout(()=>{

    firebase
      .firestore()
      .collection("users")
      .doc(currentUser.uid)
      .get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setUser(snapshot.data());
          console.log("USERID", currentUser.uid)
          console.log("USER", user)

        } else {
          console.log("does not exist");
        }
      });
    }, 1000)
}, []);
  // Fetch users from Firestore when the component mounts
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'users'));
        // Ensure each user document includes accessToken (and other fields) if applicable.
        const usersData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setUsers(usersData);
      } catch (error) {
        console.error('Error fetching users: ', error);
      }
    };

    fetchUsers();
  }, []);


  const OpenModalButton = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Housing Authority</button>
        <StateModal open={open} onClose={handleClose} />
      </>
    );
  };
  const OpenModalButton2 = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Tenant Lookup</button>
        <TenantModal open={open} onClose={handleClose} />
      </>
    );
  };

  // Fetch site statistics from Firestore
  useEffect(() => {
    const fetchAllStats = async () => {
      try {
        const [firebaseSnap, downloadRes] = await Promise.all([
          getDoc(doc(db, 'stats', 'siteStats')),
          fetch("https://api-vasejd2hkq-uc.a.run.app/downloads")
        ]);
  
        const firebaseData = firebaseSnap.exists() ? firebaseSnap.data() : {};
        const downloadData = await downloadRes.json();
  
        setStats({
          totalTraffic: downloadData.downloads,
          activeUsers: firebaseData.activeUsers ?? 0
        });
      } catch (err) {
        console.error("Failed to fetch stats:", err);
      }
    };
  
    fetchAllStats();
  }, []);
  

  // Open modal to edit a user's data
  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditModalOpen(true);
  };

  // Close modal without saving
  const handleCloseModal = () => {
    setEditModalOpen(false);
    setSelectedUser(null);
  };

  // Save updated user to Firestore and update the local state
  const handleSaveUser = async () => {
    if (!selectedUser) return;
    try {
      const userDocRef = doc(db, 'users', selectedUser.id);
      await updateDoc(userDocRef, {
        name: selectedUser.name,
        email: selectedUser.email,
        role: selectedUser.role,
        accessToken: selectedUser.accessToken,
        marketResearchSearches: selectedUser.marketResearchSearches,
        rentometerSearches: selectedUser.rentometerSearches,
        skipTracingSearches: selectedUser.skipTracingSearches,
        totalSearches: selectedUser.totalSearches,
      });
      // Update local state to reflect changes
      setUsers((prevUsers) =>
        prevUsers.map((u) => (u.id === selectedUser.id ? selectedUser : u))
      );
      handleCloseModal();
    } catch (error) {
      console.error('Error updating user: ', error);
    }
  };

  // Filter users using the searchTerm. Converting values to strings for filtering.
  const filteredUsers = users.filter((user) => {
    const term = searchTerm.toLowerCase();
    return (
      (user.name ? user.name.toString().toLowerCase() : '').includes(term) ||
      (user.email ? user.email.toString().toLowerCase() : '').includes(term) ||
      (user.accessToken ? user.accessToken.toString().toLowerCase() : '').includes(term)
    );
  });

  // Function to send push notifications via Expo's API
  const handleSendPushNotification = async () => {
    const payload = {
      pushToken,
      notificationTitle,
      notificationBody,
    };
  
    try {
      const response = await fetch("https://api-vasejd2hkq-uc.a.run.app/notify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      console.log("Notification response:", data);
      if (response.ok) {
        setNotificationStatus("Notification sent successfully!");
      } else {
        setNotificationStatus("Error sending notification.");
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      setNotificationStatus("Error sending notification.");
    }
  };
if (user ) {
    return (
        <div className="offer" >
        {/* <h1 className="offer__title4">Deal Calculator</h1> */}
        { user.role === 'Admin' && 
    <>
        <div style={{ display: "flex", height: "100vh"}}>
            
        <Sidebar style={{ backgroundColor: '#000222 '}}>
        <Menu style={{ backgroundColor: '#000222'}}>
            <MenuItem >
            <div style={{marginLeft:-43, backgroundColor: 'white'}}>
            <img
              src="https://i.ibb.co/s2dBvDt/elevate.png"
              alt="logo"
              className="ml-4 mt-12 -p-4 "
              width={300}
            ></img>
            </div>
            </MenuItem>
            
            <MenuItem style={{ backgroundColor: '#000222', color:'white', marginTop:'50px'}} onClick ={()=> window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'propertylookup'}icon={<SearchIcon />}>Market Research</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>
    
            <SubMenu label="Education" style={{ backgroundColor: '#000222', color:'white'}} icon={<SchoolIcon />}>
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}}  onClick ={()=> window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>
    
              <MenuItem icon={<AccountBalanceRoundedIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://elevatecoachingrei.com/', "_blank")}>
                Coaching
              </MenuItem>
              <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
                1-on-1s
              </MenuItem>
              <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
                Day in the Office
              </MenuItem>
              <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
                Ride Along
              </MenuItem>
    
            </SubMenu>
            {/* <MenuItem icon={<GroupIcon />}>Tenant Finder</MenuItem> */}
            <SubMenu label="Tenant Hub" style={{ backgroundColor: '#000222', color:'white'}} icon={<GroupIcon />}>
              <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<HouseIcon />}> <OpenModalButton/> </MenuItem>
              <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<EmojiPeopleIcon />}> <OpenModalButton2/> </MenuItem>
             
            </SubMenu>
            
              <MenuItem icon={<NoteAddIcon />} disabled style={{ backgroundColor: '#000222', color:'white'}}> Title Setup <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color:'#000222', width:80, height:10, fontSize:8,  marginLeft:'-15px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
              
              
             
                          <MenuItem icon={<GavelIcon />} disabled style={{ backgroundColor: '#000222', color:'white'}}> Legal Hub <Chip label={'Coming Soon!'} style={{ backgroundColor: 'white', color:'#000222', width:80, height:10, fontSize:8,  marginLeft:'-10px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
    
             
            <SubMenu label="Insurance Hub" style={{ backgroundColor: '#000222', color:'white'}} icon={<GppGoodIcon />}>
              
              <MenuItem icon={<SupportIcon />} onClick ={()=> window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>
              <MenuItem disabled icon={<CottageIcon />}> Home Warrenties <Chip label={'Coming Soon!'} style={{ backgroundColor: '#000222', color:'white', width:80, height:10, fontSize:8,  marginLeft:'-95px', fontWeight:600, marginTop:'-23px'}}/></MenuItem>
              
            </SubMenu>
            <SubMenu label="Business Setup" style={{ backgroundColor: '#000222', color:'white'}} icon={<BusinessIcon />}>
              
              <MenuItem icon={<AddIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Form Entity </MenuItem>
              <MenuItem icon={<RequestQuoteIcon />}onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Taxes </MenuItem>
              <MenuItem icon={<CreditScoreIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Build Credit </MenuItem>
              <MenuItem icon={<LockIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Asset Protection </MenuItem>
              <MenuItem icon={<AttachMoneyIcon />} onClick ={()=> window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")} > Business Funding </MenuItem>
              
             
            </SubMenu>
            <SubMenu label="Elevate Financial" style={{ backgroundColor: '#000222', color:'white'}} icon={<PaidIcon />}>
              <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} onClick ={()=> window.open('https://lendsimpli.com/elevate/', "_blank")}  icon={<CurrencyExchangeIcon />}   > Loan Portal </MenuItem>
              <MenuItem style={{ backgroundColor: 'white', color:'#000222'}} icon={<SpeedIcon />}> Credit Tradelines </MenuItem>
              
             
            </SubMenu>
            {/* <SubMenu label="Settings" style={{ backgroundColor: '#000222', color:'white'}} icon={<SettingsSuggestIcon />}>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<AccountCircleRoundedIcon />}> Account </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<ShieldRoundedIcon />}> <OpenModalButton/> </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<NotificationsRoundedIcon />}>
                Notifications
              </MenuItem>
            </SubMenu> */}
            <MenuItem style={{ backgroundColor: '#000222', color:'white'}} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect:true })}> Logout </MenuItem>
            <div style={{ ...styles.container1, backgroundColor: '#000222',  }}>
            <ProfileComponent user={user } />
    
      </div>
          </Menu>
        </Sidebar>
        
        
        <Container maxWidth="lg" sx={{ marginTop: 4, marginBottom: 4 }}>
          <Grid container spacing={3}>
            {/* Statistics Cards */}
            <Grid item xs={12} md={4}>
              <Paper sx={{ padding: 2 }}>
                <Typography variant="h6" gutterBottom>
                  User Count
                </Typography>
                <Typography variant="h3" color="primary">
                  {users.length}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
  <Paper sx={{ padding: 2 }}>
    <Typography variant="h6" gutterBottom>
      Mobile App Downloads
    </Typography>
    <Typography variant="h3" color="primary">
      {(stats.totalTraffic- 243) || 'Loading...'}
    </Typography>
  </Paper>
</Grid>
            <Grid item xs={12} md={4}>
              <Paper sx={{ padding: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Users Active Now
                </Typography>
                <Typography variant="h3" color="primary">
                  {stats.activeUsers || '3'}
                </Typography>
              </Paper>
            </Grid>
    
            {/* Users Management with Search */}
            <Grid item xs={12}>
              <Paper sx={{ padding: 2 }}>
                <Box sx={{ marginBottom: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Users
                </Typography>
                  <TextField
                    fullWidth
                    label="Search Users"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </Box>
                
                {/* Contain the table so it doesn't get too long */}
                <TableContainer sx={{ maxHeight: 400 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Access Token</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Market Research</TableCell>
                        <TableCell>Rentometer</TableCell>
                        <TableCell>Skip Tracing</TableCell>
                        <TableCell>Total Searches</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredUsers.map((user) => (
                        <TableRow key={user.id}>
                          <TableCell>{user.accessToken || 'N/A'}</TableCell>
                          <TableCell>{user.name}</TableCell>
                          <TableCell>{user.email}</TableCell>
                          <TableCell>{user.role}</TableCell>
                          <TableCell>{user.marketResearchSearches ?? 0}</TableCell>
                          <TableCell>{user.rentometerSearches ?? 0}</TableCell>
                          <TableCell>{user.skipTracingSearches ?? 0}</TableCell>
                          <TableCell>{user.totalSearches ?? 0}</TableCell>
                          <TableCell>
                            <Button variant="contained" color="primary" onClick={() => handleEditClick(user)}>
                              Edit
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                      {filteredUsers.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={9}>
                            <Typography variant="body2" align="center">
                              No users found.
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
    
            {/* Push Notification Tool */}
            <Grid item xs={12}>
              <Paper sx={{ padding: 2, marginTop: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Send Push Notification
                </Typography>
                <Box sx={{ marginBottom: 2 }}>
                  <TextField
                    fullWidth
                    label="Expo Push Token"
                    variant="outlined"
                    value={pushToken}
                    onChange={(e) => setPushToken(e.target.value)}
                    sx={{ marginBottom: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Notification Title"
                    variant="outlined"
                    value={notificationTitle}
                    onChange={(e) => setNotificationTitle(e.target.value)}
                    sx={{ marginBottom: 2 }}
                  />
                  <TextField
                    fullWidth
                    label="Notification Body"
                    variant="outlined"
                    value={notificationBody}
                    onChange={(e) => setNotificationBody(e.target.value)}
                    sx={{ marginBottom: 2 }}
                  />
                  <Button variant="contained" color="primary" onClick={handleSendPushNotification}>
                    Send Notification
                  </Button>
                </Box>
                {notificationStatus && (
                  <Typography variant="body1" color="secondary">
                    {notificationStatus}
                  </Typography>
                )}
              </Paper>
            </Grid>
          </Grid>
    
          {/* Edit User Modal */}
          <Modal open={editModalOpen} onClose={handleCloseModal}>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
              }}
            >
              <Typography variant="h6" gutterBottom>
                Edit User
              </Typography>
              {selectedUser && (
                <>
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Name"
                    value={selectedUser.name}
                    onChange={(e) => setSelectedUser({ ...selectedUser, name: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Email"
                    value={selectedUser.email}
                    onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Role"
                    value={selectedUser.role}
                    onChange={(e) => setSelectedUser({ ...selectedUser, role: e.target.value })}
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Access Token"
                    value={selectedUser.accessToken || ''}
                    onChange={(e) =>
                      setSelectedUser({ ...selectedUser, accessToken: e.target.value })
                    }
                  />
                  {/* New Editable Numeric Fields */}
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Market Research Searches"
                    type="number"
                    value={selectedUser.marketResearchSearches || 0}
                    onChange={(e) =>
                      setSelectedUser({ ...selectedUser, marketResearchSearches: parseInt(e.target.value, 10) || 0 })
                    }
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Expo Push Token"
                    type="text"
                    value={selectedUser.expoPushToken || ""}
                    onChange={(e) =>
                      setSelectedUser({ ...selectedUser, marketResearchSearches: parseInt(e.target.value, 10) || 0 })
                    }
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Rentometer Searches"
                    type="number"
                    value={selectedUser.rentometerSearches || 0}
                    onChange={(e) =>
                      setSelectedUser({ ...selectedUser, rentometerSearches: parseInt(e.target.value, 10) || 0 })
                    }
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Skip Tracing Searches"
                    type="number"
                    value={selectedUser.skipTracingSearches || 0}
                    onChange={(e) =>
                      setSelectedUser({ ...selectedUser, skipTracingSearches: parseInt(e.target.value, 10) || 0 })
                    }
                  />
                  <TextField
                    fullWidth
                    margin="normal"
                    label="Total Searches"
                    type="number"
                    value={selectedUser.totalSearches || 0}
                    onChange={(e) =>
                      setSelectedUser({ ...selectedUser, totalSearches: parseInt(e.target.value, 10) || 0 })
                    }
                  />
                  <Button variant="contained" color="primary" sx={{ marginTop: 2 }} onClick={handleSaveUser}>
                    Save
                  </Button>
                </>
              )}
            </Box>
          </Modal>
        </Container>
        </div>
        </>}
        </div>
      );
} else {
    return (
        <div></div>
    )
}
    

  
};

export default Dashboard;

const styles = {
    container: {
      margin: '20px auto',
      maxWidth: '600px',
      fontFamily: 'Arial, sans-serif',
    },
    list: {
      listStyleType: 'none',
      padding: 0,
      margin: 0,
      width:'100%',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    listItem: {
      padding: '12px 16px',
      cursor: 'pointer',
      borderBottom: '1px solid #ddd',
      backgroundColor: '#fff',
      width:'100%',
      transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    },
    listItemHover: {
      backgroundColor: '#f7f7f7',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    centerScreen: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      
      minHeight: '100vh'
    },
    container1: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      marginTop:'0px'
    },
    profile: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#000222',
      padding: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    profileAvatar: {
      width: '52px',
      height: '52px',
      borderRadius: '50%',
      marginRight: '21px',
    },
    profileName: {
      fontSize: '17px',
      fontWeight: 'bold',
      color: 'white',
      margin: 0,
    },
    profileHandle: {
      fontSize: '11px',
      color: 'white',
      margin: 0,
    },
    
  };